// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  padding: 16px 16px;
  border-bottom: 1px solid black;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/contracts/edit-contract/servicos-iniciais/servicos-iniciais.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,8BAAA;AACJ","sourcesContent":[".buttons{\n    padding: 16px 16px;\n    border-bottom: 1px solid black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
